import { ApiResponse, GenericOperationState } from '@repo/core'
import { CommunicationsData } from '@repo/mailbox-types'
import { RootState } from '../../store/types'

export const communicationsDataSelectorConfig = {
  communicationsDataSelector: {
    getRootPath: function (
      state: RootState,
    ): GenericOperationState<ApiResponse<CommunicationsData> | null> {
      return state.mailbox.communications.data
    },
  },
}
